<div class="feedback-rating-card">
  @if (submitted) {
    <div class="feedback-rating-prompt">
      Thanks for your feedback!
    </div>
  }

  <div
    class="feedback-rating-emojis"
    [class.is-disabled]="submitted"
    (mouseleave)="onLeave()"
    role="radiogroup"
    aria-label="Conversation rating"
  >
    <button
      *ngFor="let level of levels"
      type="button"
      class="feedback-rating-emoji"
      [class.active]="isEmojiActive(level)"
      [class.dimmed]="isEmojiDimmed(level)"
      [attr.aria-label]="ariaLabelForLevel(level)"
      [attr.aria-checked]="submittedRating === level"
      [disabled]="submitted"
      (mouseenter)="onHover(level)"
      (focus)="onHover(level)"
      (blur)="onLeave()"
      (click)="onSelect(level)"
    >
      <span class="emoji-stack">
        <span class="emoji-glyph" aria-hidden="true">{{
          emojiGlyphForTier(emojiTier(level))
        }}</span>
        <span class="emoji-caption" aria-hidden="true">{{
          captionForLevel(level)
        }}</span>
      </span>
    </button>
  </div>
</div>
